/* @generated */
// prettier-ignore
if (Intl.PluralRules && typeof Intl.PluralRules.__addLocaleData === 'function') {
  Intl.PluralRules.__addLocaleData({
    "data": {
      "categories": {
        "cardinal": ["other"],
        "ordinal": ["one", "other"]
      },
      "fn": function fn(n, ord) {
        if (ord) return n == 1 ? 'one' : 'other';
        return 'other';
      }
    },
    "locale": "ms"
  });
}